import type { ReactNode } from 'react';

import { Icon } from 'components/Icon/Icon';

import type { IconButtonsOption } from './IconButtonsOption';
import {
  IconSelectHolder,
  IconSelectLabel,
  IconSelectTextHolder,
} from './IconSelectButtons.styled';

type Props<TValue extends string> = {
  id?: string;
  options: IconButtonsOption<TValue>[];
  isOptionSelected: (option: IconButtonsOption<TValue>) => boolean;
  renderInput: (option: IconButtonsOption<TValue>) => ReactNode;
  qaId?: string;
};

export function IconButtons<TValue extends string>({
  id,
  options,
  isOptionSelected,
  renderInput,
  qaId,
}: Props<TValue>) {
  return (
    <IconSelectHolder id={id} data-qa-id={qaId}>
      {options.map((option) => (
        <IconSelectLabel
          key={option.value}
          $selected={isOptionSelected(option)}
          data-value={option.value}
        >
          {renderInput(option)}

          <Icon name={option.iconName} size={36} />
          <IconSelectTextHolder>{option.label}</IconSelectTextHolder>
        </IconSelectLabel>
      ))}
    </IconSelectHolder>
  );
}
